module.exports = __webpack_public_path__ + "static/convertion-rate-optimization-cb8f8d58df1de71268ec2d499bfac8c1.png";